import { PREFIX_API } from 'constants/api.const';
import qs from 'query-string';
import {
  MediaPlaylistRequestModel,
  PlaylistMediaResponseModel,
  PlaylistStateModel,
} from 'models/photo/playlist-ads.model';
import { baseSliceApi } from './base.slice-api';

export const playListApi = baseSliceApi.injectEndpoints({
  endpoints: (build) => ({
    getPlaylistApiAction: build.query<
      PlaylistStateModel['mediaPlaylist'],
      MediaPlaylistRequestModel
    >({
      query: (payload) => ({
        url: `${PREFIX_API.API}/media-ads/getlist?${qs.stringify(payload)}`,
      }),
      transformResponse: (rawResult: PlaylistMediaResponseModel) => ({
        data: rawResult?.response?.data ?? [],
        totalRecord: rawResult?.response?.totalRecord ?? 0,
      }),
      extraOptions: { maxRetries: 1 },
    }),
  }),
});

export const { useGetPlaylistApiActionQuery } = playListApi;

export const {
  endpoints: { getPlaylistApiAction },
} = playListApi;
